import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";

import {
  FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS,
  FETCH_ALL_LOAN_BENEFICIARIES_LS,
  FETCH_DATA_FOR_PRINTING,
  ADD_PAYMENT_TO_LOAN_BENEFICIARY,
  FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID,
  FETCH_PAYMENT_BY_PAYMENT_ID,
  EXPORT_LOAN_BENEFICIARIES,
  FETCH_ALL_LOANS_FOR_FILTER,
  FETCH_LOAN_BENEFICIARY_BY_ID,
} from "../ActionTypes";

import {
  fetchTotalLoanBeneficiariesDetailsSuccess,
  fetchAllLoanBeneficiariesLsSuccess,
  fetchDataForPrintingSuccess,
  addPaymentToLoanBeneficiarySuccess,
  fetchPaymentByLoanBeneficiaryIdSuccess,
  fetchPaymentByPaymentIdSuccess,
  exportLoanBeneficiariesSuccess,
  fetchAllLoansForFilterSuccess,
  fetchLoanBeneficiaryByIdSuccess
} from "../Actions";

import {
  getTotalLoanBeneficiariesDetails,
  getAllLoanBeneficiariesAPI,
  getAllLoanBeneficiariesNoPagination,
  addPaymentToLoanBeneficiaryAPI,
  getPaymentByLoanBeneficiaryIdAPI,
  getPaymentByPaymentIdAPI,
  exportLoanBeneficiariesAPI,
  getAllLoanSelect,
  getLoanBeneficiaryById
} from "../Api"


// all requests
const getTotalLoanBeneficiariesDetailsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchTotalLoanBeneficiariesDetailsSuccess, getTotalLoanBeneficiariesDetails, payload)
}

const getAllLoanBeneficiariesRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllLoanBeneficiariesLsSuccess, getAllLoanBeneficiariesAPI, payload)
}

const getAllLoanBeneficiariesNoPaginationRequest = function* ({ payload }) {
  yield call(requestFunction, fetchDataForPrintingSuccess, getAllLoanBeneficiariesNoPagination, payload)
}

const addPaymentToLoanBeneficiaryRequest = function* ({ payload }) {
  yield call(requestFunction, addPaymentToLoanBeneficiarySuccess, addPaymentToLoanBeneficiaryAPI, payload)
}

const getPaymentByLoanBeneficiaryIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchPaymentByLoanBeneficiaryIdSuccess, getPaymentByLoanBeneficiaryIdAPI, payload)
}

const getPaymentByPaymentIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchPaymentByPaymentIdSuccess, getPaymentByPaymentIdAPI, payload)
}

const exportLoanBeneficiariesRequest = function* ({ payload }) {
  yield call(requestFunction, exportLoanBeneficiariesSuccess, exportLoanBeneficiariesAPI, payload)
}

const getAllLoansForFilterRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllLoansForFilterSuccess, getAllLoanSelect, payload)
}
const getLoanBeneficiaryByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchLoanBeneficiaryByIdSuccess, getLoanBeneficiaryById, payload)
}

// all watchers
export const getTotalLoanBeneficiariesDetailsWatcher = function* () {
  yield takeEvery(FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS, getTotalLoanBeneficiariesDetailsRequest)
}

export const getAllLoanBeneficiariesWatcher = function* () {
  yield takeEvery(FETCH_ALL_LOAN_BENEFICIARIES_LS, getAllLoanBeneficiariesRequest)
}

export const getAllLoanBeneficiariesNoPaginationWatcher = function* () {
  yield takeEvery(FETCH_DATA_FOR_PRINTING, getAllLoanBeneficiariesNoPaginationRequest)
}

export const addPaymentToLoanBeneficiaryWatcher = function* () {
  yield takeEvery(ADD_PAYMENT_TO_LOAN_BENEFICIARY, addPaymentToLoanBeneficiaryRequest)
}

export const getPaymentByLoanBeneficiaryIdWatcher = function* () {
  yield takeEvery(FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID, getPaymentByLoanBeneficiaryIdRequest)
}

export const getPaymentByPaymentIdWatcher = function* () {
  yield takeEvery(FETCH_PAYMENT_BY_PAYMENT_ID, getPaymentByPaymentIdRequest)
}

export const exportLoanBeneficiariesWatcher = function* () {
  yield takeEvery(EXPORT_LOAN_BENEFICIARIES, exportLoanBeneficiariesRequest)
}

export const getAllLoansForFilterWatcher = function* () {
  yield takeEvery(FETCH_ALL_LOANS_FOR_FILTER, getAllLoansForFilterRequest)
}
export const getLoanBeneficiaryByIdWatcher = function* () {
  yield takeEvery(FETCH_LOAN_BENEFICIARY_BY_ID, getLoanBeneficiaryByIdRequest)
}

export default function* rootSaga() {
  yield all([
    fork(getTotalLoanBeneficiariesDetailsWatcher),
    fork(getAllLoanBeneficiariesWatcher),
    fork(getAllLoanBeneficiariesNoPaginationWatcher),
    fork(addPaymentToLoanBeneficiaryWatcher),
    fork(getPaymentByLoanBeneficiaryIdWatcher),
    fork(getPaymentByPaymentIdWatcher),
    fork(exportLoanBeneficiariesWatcher),
    fork(getAllLoansForFilterWatcher),
    fork(getLoanBeneficiaryByIdWatcher),
  ])
}